module.exports = __webpack_public_path__ + "d0040386a8fe205bb5b9b0a5be286de6.svg";